/**
 * Short product links.
 *
 * 87% of this catalogue's slugs are non-ASCII, and percent-encoded Arabic
 * costs ~9 characters a letter — a canonical product URL runs past 250
 * characters, which cannot be pasted into an Instagram story.
 *
 * Every slug already ends in a unique 8-hex suffix (…-1b12cb45), so the short
 * form needs no lookup table and no migration: the code is a substring of the
 * slug already stored. `/p/<code>` redirects to the canonical URL.
 *
 * Kept free of framework imports so it can be unit-tested directly.
 */

/** The suffix every generated slug carries. */
export const SHORT_CODE = /-([0-9a-f]{8})$/i;

/**
 * Rewrite a canonical product URL to its short form, or return null when the
 * slug has no recognisable code (older or hand-written slugs).
 *
 * Deliberately drops any `variant` param: brevity is the whole point, and the
 * recipient can choose a variant on arrival in one tap.
 */
export function shortProductUrl(canonicalUrl: string): string | null {
  const match = canonicalUrl.match(/\/products\/(.+)$/);
  if (!match) return null;
  const slug = decodeURIComponent(match[1].split(/[?#]/)[0]);
  const code = slug.match(SHORT_CODE)?.[1];
  if (!code) return null;
  return new URL(`/p/${code}`, canonicalUrl).toString();
}
